import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter, browserHistory } from 'react-router';
import restrictedIcon from 'assets/images/backoffice/online-store/restricted.svg';
import { closeGoStoreUnActivatedModal } from 'actions/onlineStore';
import { ONLINE_STORE_CHANNEL } from 'utils/onlineStoreUtils';
import WarningModal from '../WarningModal';

const channelText = {
  [ONLINE_STORE_CHANNEL.FACEBOOK]: 'Facebook & Instagram Shop',
  [ONLINE_STORE_CHANNEL.GOOGLE]: 'Google Shopping',
};

class GoStoreNotActivatedModal extends React.Component {
  render() {
    const { outletName, channel, showGoStoreNotActivatedModal } = this.props;

    if (!showGoStoreNotActivatedModal) {
      return null;
    }

    return (
      <WarningModal
        backdrop="static"
        onClick={this._handleClick}
        imageSrc={restrictedIcon}
        title="Activate GoStore for"
        titleBold={outletName}
        text={`Oops, you can't connect to ${channelText[channel]} because your GoStore for this outlet is not activated yet`}
        buttonText="Active GoStore Now"
        onHide={this._handleHide}
      />
    );
  }

  _handleHide = () => {
    this.props.dispatch(closeGoStoreUnActivatedModal());
  };

  _handleClick = () => {
    this._handleHide();
    browserHistory.push(`/online-store/gostore`);
  };
}

function mapStateToProps(state) {
  const {
    outletName,
    channel,
    showGoStoreNotActivatedModal,
  } = state.onlineStore.outletModal;

  return {
    outletName,
    channel,
    showGoStoreNotActivatedModal,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

const connected = connect(
  mapStateToProps,
  mapDispatchToProps
)(GoStoreNotActivatedModal);

export default withRouter(connected);
